import { Box, Popover, Stack, Typography } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import { sendUserAttributeVerificationCode } from 'aws-amplify/auth';
import React, { useEffect, useState } from 'react';
import { Schema } from '../../../../../amplify/data/resource';
import LoadingIcon from '../../../../components/activeIcons/LoadingIcon';
import EditClient from './EditClient';

interface Props {
  open: boolean;
  client: any;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const apiClient = generateClient<Schema>();

const Info: React.FC<Props> = ({ open, client, anchorEl, onClose }) => {
  const [editOpen, setEditOpen] = useState(false);

  const toggleEditClient = () => {
    setEditOpen(!editOpen);
  };

  const [phoneVerified, setPhoneVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);

  useEffect(() => {
    const fetchUserInfo = async () => {
      const userAttributes = await apiClient.queries.getUserInfo({
        userId: client.id,
      });

      if (
        userAttributes.data !== null &&
        typeof userAttributes.data === 'string'
      ) {
        const parsedUserAttributes = JSON.parse(userAttributes.data);

        console.log('parsedUserAttributes', parsedUserAttributes);

        setPhoneVerified(parsedUserAttributes.body.phone.verified);
        setEmailVerified(parsedUserAttributes.body.email.verified);
      } else {
        console.warn('userAttributes.data is null or not a string');
      }
    };
    if (client) {
      fetchUserInfo();
    }
  }, [client]);

  const handleSendAttributesVerification = async () => {
    const response = await sendUserAttributeVerificationCode({
      userAttributeKey: 'email',
    });
    console.log('response', response);
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          boxShadow: '0px 0px 10px 0px #00000026',
          borderRadius: '15px',
          overflow: 'hidden',
        },
      }}
    >
      <Stack spacing={2} sx={{ px: '40px', py: '20px', minWidth: '300px' }}>
        <Stack direction="row" justifyContent={'space-between'}>
          <Stack direction="row" spacing={1}>
            <img
              alt="logo"
              src={'/assets/client/edit.svg'}
              style={{ cursor: 'pointer' }}
              onClick={toggleEditClient}
            />
            <img
              alt="logo"
              src={'/assets/client/send.svg'}
              style={{ cursor: 'pointer' }}
              onClick={handleSendAttributesVerification}
            />
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography
              whiteSpace="nowrap"
              fontSize="24px"
              fontWeight="700"
              fontFamily={'AlmoniDL'}
            >
              פרטי לקוח
            </Typography>
            <img alt="logo" src={'/assets/client/client.svg'} />
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent={'space-between'}>
          <Stack spacing={1}>
           <Item title={'בנק'} value={client?.paymentInfo?.bank} />
            <Item title={'סניף'} value={client?.paymentInfo?.branch} />
            <Item title={'מספר חשבון'} value={client?.paymentInfo?.account} />
           
            <Stack>
              <Item title={'מקור'} value={client?.source} />
            </Stack>
          </Stack>
          <Stack spacing={1}>
            <Item title={'שם העסק'} value={client?.companyName} />
            <Item title={'ח.פ.'} value={client?.companyRegistrationNumber} />
            <Item
              title={'שם מורשה חתימה'}
              value={client?.authorizedSignatoryName}
            />
            <Item
              title={'תעודת זהות'}
              value={client?.userId}
            />
            <Box sx={{ position: 'relative' }}>
              <Item
                title={'טלפון לשליחת ווטסאפ'}
                value={client?.authorizedSignatoryPhone}
              />
              <Box sx={{ position: 'absolute', right: '-25px', top: '0%' }}>
                <LoadingIcon loading={!phoneVerified} />
              </Box>
            </Box>
            <Box sx={{ position: 'relative' }}>
              <Item title={'מייל'} value={client?.email} />
              <Box sx={{ position: 'absolute', right: '-25px', top: '0%' }}>
                <LoadingIcon loading={!emailVerified} />
              </Box>
            </Box>
          </Stack>
        </Stack>
      </Stack>
      <EditClient open={editOpen} onClose={toggleEditClient} client={client} />
    </Popover>
  );
};

export default Info;

interface ItemProps {
  title: string | undefined;
  value: string | undefined;
}

const Item: React.FC<ItemProps> = ({ title, value }) => {
  return (
    <Stack>
      <Typography
        dir="rtl"
        fontSize="14px"
        fontWeight="700"
        fontFamily="AlmoniDL"
      >
        {title || 'XXXXXXXXXX'}
      </Typography>
      <Typography
        dir="rtl"
        fontSize="14px"
        fontWeight="300"
        fontFamily="AlmoniDL"
      >
        {value || 'XXXXXXXXXX'}
      </Typography>
    </Stack>
  );
};
